import { useCallback, useEffect, useState } from "react";
import { IPageSearch } from "../allPageSearch.interface";
import allPageSearchService from "../allPageSearchService";
import { AxiosResponse } from "axios";
import ISearchParams from "../searchParams.interface";

const useSearch = (filters?: ISearchParams, enabled = true) => {
  const [data, setData] = useState<IPageSearch>();
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState<unknown>("");

  const callApi = useCallback(() => {
    return allPageSearchService.search(filters);
  }, [filters]);

  const transformResponse = useCallback((response: AxiosResponse<IPageSearch>) => {
    if (response) {
      setData(response.data);
    }
  }, []);

  const refetch = useCallback(async () => {
    try {
      setLoading(true);
      const response = await callApi();
      transformResponse(response);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    (async () => {
      try {
        setLoading(true);
        const response = await callApi();
        transformResponse(response);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    })();
  }, [enabled]);

  return { data, error, isLoading, refetch };
};

export default useSearch;
